import styled from 'styled-components'

import FormSubmitButton from '../../form/FormSubmitButton'
import FormFieldEmail from '../../form/fields/FormFieldEmail'
import FormFieldInput from '../../form/fields/FormFieldInput'
import FormikForm from '../../form/FormikForm'
import { Label as FormFieldInputLabel } from '../../form/fields/FormFieldInput/styled'
import { mq, sizes } from '../../theme'

export const Container = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Form = styled(FormikForm)`
  width: 100%;
`

export const Fields = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 3rem;
`

export const EmailField = styled(FormFieldEmail)`
  ${FormFieldInputLabel} {
    @media ${mq(sizes.mobile)} {
      flex: 1;
    }
  }
  @media ${mq(sizes.mobile)} {
    > div {
      flex: 3;
    }
  }
`

export const TextField = styled(FormFieldInput)`
  ${FormFieldInputLabel} {
    @media ${mq(sizes.mobile)} {
      flex: 1;
    }
  }
  @media ${mq(sizes.mobile)} {
    > div {
      flex: 3;
    }
  }
`

export const Group = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: 3rem;

  @media ${mq(sizes.desktop)} {
    gap: 10rem;
  }

  @media ${mq(sizes.tablet)} {
    gap: 5rem;
    grid-template-columns: 1fr 1fr;
  }
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 1rem;
  margin: 2rem auto 0 auto;
`

export const ForgottenButton = styled(FormSubmitButton)``
export const SubmitButton = styled(FormSubmitButton)``
